import React from 'react'
import { useTranslation } from 'react-i18next'
import { Bot } from 'lucide-react'
import AiCopilotDrawer from './AiCopilotDrawer'
import { useAppDispatch, useAppSelector } from '@/redux/hooks'
import { toggleDrawer } from '@/redux/slices/aiSlice'
import { usePermission } from '@/hooks/usePermission'
import { ErpButtonRaw } from '@/components/erp'

/**
 * Floating launcher + global copilot drawer, mounted once in the app
 * layout and gated by the aiChatUse permission.
 */
export const AiLauncher: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const drawerOpen = useAppSelector((state) => state.ai.drawerOpen)
  const { can } = usePermission()

  if (!can('aiChatUse')) return null

  return (
    <>
      {!drawerOpen && (
        <ErpButtonRaw
          type="button"
          aria-label={t('AI_Assistant')}
          title={t('AI_Assistant')}
          className="fixed bottom-6 z-40 flex h-12 w-12 items-center justify-center rounded-full bg-primary text-primary-foreground shadow-lg transition-transform hover:scale-105 ltr:right-6 rtl:left-6"
          onClick={() => dispatch(toggleDrawer())}
        >
          <Bot className="h-6 w-6" />
        </ErpButtonRaw>
      )}

      <AiCopilotDrawer />
    </>
  )
}

export default AiLauncher
